import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    cardContainer: {
      display: 'flex',
      gap: '20px',
      flexWrap: 'wrap',
      '@media (max-width: 768px)': {
        justifyContent: 'center'
      }
    },
    card: {
      width: '300px',
      '& > div': {
        '@media (max-width: 425px)': {
          height: 'auto'
        },
        height: '300px'
      },
      '& p': {
        fontSize: '13px'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
